import { render, staticRenderFns } from "./PeriodicalPeriods.vue?vue&type=template&id=e54542e0&scoped=true"
import script from "./PeriodicalPeriods.vue?vue&type=script&lang=js"
export * from "./PeriodicalPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54542e0",
  null
  
)

export default component.exports